import axios from '../../http';

function initialState() {
  return {
    requesting: {},
    vehicle: {},
    vehicleMakes: [],
    vehicleModels: [],
    vehicleEngines: [],
    compareVehicles: [],
    vehicleChargeTypes: [],
    suppliers: [],
    suppliersGas: [],
    suppliersElectricity: [],
    addresses: [],
    usageTypes: [
      { label: 'I spend', value: 0 },
      { label: 'I use', value: 1 }
    ],
    usageUnits: [
      { label: 'yearly', value: 1 },
      { label: 'monthly', value: 2 },
      { label: 'quarterly', value: 3 }
    ],
    tariffs: [],
    tariffsGas: [],
    tariffsElectricity: [],
    paymentMethods: [
      { name: 'monthlyDirectDebit', label: 'Monthly Direct Debit' },
      { name: 'quarterlyDirectDebit', label: 'Quarterly Direct Debit' },
      { name: 'cashOrCheque', label: 'Cash & Cheque' },
      { name: 'prePaymentMeter', label: 'Prepayment Meter' }
    ],
    propertyTypes: [],
    ashpPropertyTypes: [],
    esaPropertyTypes: [],
    insulationTypes: [],
    heatingTypes: [],
    fuelTypes: [
      { name: 'gas', label: 'Gas' },
      { name: 'electricity', label: 'Electricity' },
      { name: 'gasElectricity', label: 'Gas & Electricity' }
    ],
    rateTypes: [
      { name: 'any', label: 'Any' },
      { name: 'fixed', label: 'Fixed' },
      { name: 'variable', label: 'Variable' }
    ],
    greens: [
      { value: 'any', label: 'Any' },
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' }
    ],
    prepayments: [
      { label: 'Pre-Pay Key Meter', id: 1 },
      { label: 'Pre-Pay Token Meter', id: 2 },
      { label: 'Pre-Pay Smartcard Meter', id: 3 }
    ],
    houseTypes: [],
    houseUsageTypes: [
      {
        id: 1,
        label: 'All day'
      },
      {
        id: 2,
        label: 'About half a day'
      },
      {
        id: 3,
        label: 'Out all day'
      },
      {
        id: 4,
        label: 'Unsure'
      }
    ],
    bedRooms: [],
    occupancyFrequencies: [],
    energyEfficiencies: [],
    fuelUseTypes: [],
    employmentStatuses: [],
    titles: [],
    specialNeeds: [],
    residentialStatuses: [],
    directDebitDays: []
  };
}

const state = initialState();

const getters = {};

const actions = {
  async findVehicle({ commit }, { registrationNumber, ev }) {
    try {
      commit('updateRequesting', { prop: 'vehicle', value: true });

      const res = await axios({
        method: 'POST',
        url: '/request/ev/regno',
        data: { registrationNumber }
      });

      if (ev == false && res.data.isEv) return 409;
      if (ev == true && !res.data.isEv) return 409;

      return res.data;
    } catch ({ status, data }) {
      return status;
    } finally {
      commit('updateRequesting', { prop: 'vehicle', value: false });
    }
  },
  async getVehicleMakes({ commit }, { electricVehicle }) {
    try {
      commit('updateRequesting', { prop: 'vehicleMakes', value: true });
      const res = await axios({
        method: 'GET',
        url: '/request/ev/make',
        params: {
          isEv: electricVehicle ? 1 : 0
        }
      });

      commit('updateState', {
        prop: 'vehicleMakes',
        value: res.data
      });

      commit('updateRequesting', { prop: 'vehicleMakes', value: false });
    } catch ({ data }) {
      commit('updateState', { prop: 'vehicleMakes', value: [] });
      commit('updateRequesting', { prop: 'vehicleMakes', value: false });
    }
  },
  async getVehicleModels({ commit }, { id, electricVehicle }) {
    try {
      commit('updateRequesting', { prop: 'vehicleModels', value: true });
      const res = await axios({
        method: 'GET',
        url: `/request/ev/make/${id}/model`,
        params: {
          isEv: electricVehicle ? 1 : 0
        }
      });

      commit('updateState', {
        prop: 'vehicleModels',
        value: res.data
      });
      commit('updateRequesting', { prop: 'vehicleModels', value: false });
    } catch ({ data }) {
      commit('updateState', { prop: 'vehicleModels', value: [] });
      commit('updateRequesting', { prop: 'vehicleModels', value: false });
    }
  },
  async getVehicleEngines({ commit }, { id }) {
    try {
      commit('updateRequesting', { prop: 'vehicleEngines', value: true });
      const res = await axios({
        method: 'GET',
        url: `/request/ev/model/${id}/enginesize`
      });

      commit('updateState', { prop: 'vehicleEngines', value: res.data });
      commit('updateRequesting', { prop: 'vehicleEngines', value: false });
    } catch ({ data }) {
      commit('updateState', { prop: 'vehicleEngines', value: [] });
      commit('updateRequesting', { prop: 'vehicleEngines', value: false });
    }
  },
  async getVehicleDetails({ commit }, { makeId, modelId }) {
    try {
      commit('updateRequesting', { prop: 'vehicleDetails', value: true });
      const res = await axios({
        method: 'GET',
        url: `/request/ev/make/${makeId}/model/${modelId}`
      });

      commit('updateRequesting', { prop: 'vehicleDetails', value: false });
      return res.data;
    } catch ({ data }) {
      commit('updateState', { prop: 'vehicleEngines', value: [] });
      commit('updateRequesting', { prop: 'vehicleDetails', value: false });
    }
  },
  async getVehicleChargeTypes({ commit }) {
    try {
      commit('updateRequesting', { prop: 'vehicleChargeTypes', value: true });

      commit('updateState', {
        prop: 'vehicleChargeTypes',
        value: [
          { label: 'Fast (7kW)', id: 1 },
          { label: '3 Pin Wall Plug (3kW)', id: 3 }
        ]
      });

      commit('updateRequesting', { prop: 'vehicleChargeTypes', value: false });
    } catch ({ data }) {
      commit('updateState', { prop: 'vehicleChargeTypes', value: [] });
      commit('updateRequesting', { prop: 'vehicleChargeTypes', value: false });
    }
  },
  async getSuppliers({ rootState, rootGetters, commit }, fuelType) {
    const { quote } = rootState;
    const switchType = rootGetters['quote/quoteType'];
    let prop = fuelType === 'gas' ? 'suppliersGas' : 'suppliersElectricity';
    const paymentKey =
      fuelType === 'gas'
        ? 'gasCurrentPayMethod'
        : 'electricityCurrentPayMethod';
    const data = {
      postcode: quote.postcode,
      switchType: fuelType === 'gas' ? 'gasToGas' : 'electricityToElectricity',
      currentPayMethod: quote[paymentKey],
      economy7Percentage: quote.isEconomy7 ? 1 : 0
    };

    if (switchType === 'dualConsolidatedToDualConsolidated') {
      prop = 'suppliers';
      data.switchType = switchType;
      data.currentPayMethod = quote.currentPayMethod;
    }

    const valid =
      fuelType && data.postcode && data.switchType && data.currentPayMethod;

    if (!valid) return;

    try {
      commit('updateRequesting', { prop, value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/suppliers',
        data
      });

      const suppliersDto = res.data.suppliersDto;
      commit('updateState', {
        prop,
        value:
          suppliersDto.electricitySuppliers ||
          suppliersDto.gasSuppliers ||
          suppliersDto.dualConsolidatedSuppliers
      });
      commit('updateRequesting', { prop, value: false });
    } catch (error) {
      commit('updateState', { prop, value: [] });
      commit('updateRequesting', { prop, value: false });
    }
  },
  async getAddresses({ rootState, commit, dispatch }, postcode) {
    const { gbData } = rootState.app_settings;
    commit('updateRequesting', { prop: 'addresses', value: true });

    try {
      if (gbData) {
        const res = await axios({
          method: 'GET',
          url: '/request/address/list/postcode',
          params: { postcode }
        });

        commit('updateState', {
          prop: 'addresses',
          value: res.data.verifiedAddresses
        });
      } else {
        const res = await axios({
          method: 'GET',
          url: '/request/address/recco',
          params: { postcode }
        });
        commit('updateState', { prop: 'addresses', value: res.data });
      }

      commit('updateRequesting', { prop: 'addresses', value: false });
    } catch ({ data }) {
      commit('updateState', { prop: 'addresses', value: [] });
      commit('updateRequesting', { prop: 'addresses', value: false });
    }
  },
  async getXoserveMeters({ commit, dispatch }, data) {
    const empty = [{ elecdetails: [], gasdetails: [], mpan: null, mprn: null }];
    const { xoserveAddressCode, mpancore, ...rest } = data;

    try {
      commit('updateRequesting', { prop: 'xoserveMeters', value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/address/recco/details',
        data: {
          ...rest,
          mpanCores: data.mpancore,
          xoserveAddressCodes: data.xoserveAddressCode
        }
      });

      if (res.status == 200 && res.data.length) {
        const model = res.data[0];

        return {
          ...model,
          elecdetails: model.elecdetails || [],
          gasdetails: model.gasdetails || []
        };
      }

      return empty;
    } catch ({ data }) {
      return empty;
    } finally {
      commit('updateRequesting', { prop: 'xoserveMeters', value: false });
    }
  },
  async getTariffs(
    { rootState, rootGetters, commit, dispatch },
    { fuelType, supplierId }
  ) {
    const { quote } = rootState;
    const quoteType = rootGetters['quote/quoteType'];
    let prop = fuelType === 'gas' ? 'tariffsGas' : 'tariffsElectricity';
    const paymentKey =
      fuelType === 'gas'
        ? 'gasCurrentPayMethod'
        : 'electricityCurrentPayMethod';
    const data = {
      switchType: fuelType === 'gas' ? 'gasToGas' : 'electricityToElectricity',
      supplierId,
      postcode: quote.postcode,
      currentPayMethod: quote[paymentKey],
      economy7Percentage: quote.isEconomy7 ? 1 : 0
    };

    if (quoteType === 'dualConsolidatedToDualConsolidated') {
      prop = 'tariffs';
      (data.switchType = quoteType),
        (data.currentPayMethod = quote.currentPayMethod);
    }

    const valid =
      fuelType &&
      supplierId &&
      data.postcode &&
      data.switchType &&
      data.currentPayMethod;

    if (!valid) return;

    try {
      commit('updateRequesting', { prop, value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/tariffs',
        data
      });

      commit('updateState', {
        prop,
        value: res.data.tariffsDto.tariffs
      });
      commit('updateRequesting', { prop, value: false });
    } catch ({ data }) {
      commit('updateState', { prop, value: [] });
      commit('updateRequesting', { prop, value: false });
    }
  },
  async getEstimateList({ commit, dispatch }) {
    try {
      commit('updateRequesting', { prop: 'estimate', value: true });
      const res = await axios({
        method: 'GET',
        url: '/request/estimation/detail/all'
      });

      const { data } = res;

      commit('updateState', {
        prop: 'bedRooms',
        value: data.response.bedRooms
      });
      commit('updateState', {
        prop: 'fuelUseTypes',
        value: data.response.fuelUseTypes
      });
      commit('updateState', {
        prop: 'houseTypes',
        value: data.response.houseTypes
      });
      commit('updateState', {
        prop: 'occupancyFrequencies',
        value: data.response.occupancyFrequencies
      });
      commit('updateState', {
        prop: 'energyEfficiencies',
        value: data.response.energyEfficiencies
      });
      commit('updateRequesting', { prop: 'estimate', value: false });
    } catch (error) {
      commit('updateState', { prop: 'bedRooms', value: [] });
      commit('updateState', { prop: 'fuelUseTypes', value: [] });
      commit('updateState', { prop: 'houseTypes', value: [] });
      commit('updateState', { prop: 'occupancyFrequencies', value: [] });
      commit('updateState', { prop: 'energyEfficiencies', value: [] });
      commit('updateRequesting', { prop: 'estimate', value: false });
    }
  },
  async getPropertyList({ state, commit, rootState }) {
    const { switchKey, quote } = rootState.storage;
    if (state.propertyTypes.length) return;

    try {
      commit('updateRequesting', { prop: 'propertyTypes', value: true });
      const res = await axios({
        method: 'GET',
        url: 'request/customer/property'
      });

      commit('updateState', { prop: 'propertyTypes', value: res.data });
      commit('updateRequesting', { prop: 'propertyTypes', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'propertyTypes', value: false });
    }
  },
  async getAshpPropertyList({ state, commit, rootState }) {
    const { switchKey, quote } = rootState.storage;
    if (state.ashpPropertyTypes.length) return;

    try {
      commit('updateRequesting', { prop: 'ashpPropertyTypes', value: true });
      const res = await axios({
        method: 'GET',
        url: 'request/customer/property/ashp'
      });

      commit('updateState', { prop: 'ashpPropertyTypes', value: res.data });
      commit('updateRequesting', { prop: 'ashpPropertyTypes', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'ashpPropertyTypes', value: false });
    }
  },
  async getEsaPropertyList({ state, commit, rootState }) {
    const { switchKey, quote } = rootState.storage;
    if (state.esaPropertyTypes.length) return;

    try {
      commit('updateRequesting', { prop: 'esaPropertyTypes', value: true });
      const res = await axios({
        method: 'GET',
        url: 'request/customer/property/esa'
      });

      commit('updateState', { prop: 'esaPropertyTypes', value: res.data });
      commit('updateRequesting', { prop: 'esaPropertyTypes', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'esaPropertyTypes', value: false });
    }
  },
  async getInsulationList({ state, commit, rootState }) {
    const { switchKey, quote } = rootState.storage;
    const list = [
      {
        id: 1,
        label: 'Well Insulated'
      },
      {
        id: 2,
        label: 'Medium Insulated'
      },
      {
        id: 3,
        label: 'Poorly Insulated'
      }
    ];
    commit('updateState', { prop: 'insulationTypes', value: list });
  },
  async getHeatingTypeList({ state, commit, rootState }) {
    const { switchKey, quote } = rootState.storage;
    const list = [
      {
        id: 2,
        label: 'Electric Heating'
      },
      {
        id: 1,
        label: 'Gas Heating'
      },
      {
        id: 3,
        label: 'Oil Heating'
      }
    ];
    commit('updateState', { prop: 'heatingTypes', value: list });
  },
  async getEmploymentStatusList({ commit, dispatch, rootState }) {
    const { switchKey, quote } = rootState.storage;

    try {
      commit('updateRequesting', { prop: 'employmentStatuses', value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/switch/pro/detail/employment-statuses',
        data: { switchKey, isTou: quote.isTou }
      });

      const { data } = res;
      const statuses = data.employmentStatusesDto.employmentStatuses;
      const employmentStatuses = Object.entries(statuses).map((item) => ({
        id: item[0],
        label: item[1]
      }));

      commit('updateState', {
        prop: 'employmentStatuses',
        value: employmentStatuses
      });
      commit('updateRequesting', { prop: 'employmentStatuses', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'employmentStatuses', value: false });
    }
  },
  async getTitleList({ commit, rootState }) {
    const { switchKey, quote } = rootState.storage;

    try {
      commit('updateRequesting', { prop: 'titles', value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/switch/pro/detail/titles',
        data: { switchKey, isTou: quote.isTou }
      });

      const { data } = res;
      const titles = Object.entries(data.titlesDto.titles).map((item) => ({
        id: item[0],
        label: item[1]
      }));

      commit('updateState', { prop: 'titles', value: titles });
      commit('updateRequesting', { prop: 'titles', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'titles', value: false });
    }
  },
  async getSpecialNeedsList({ state, commit, rootState }) {
    const { switchKey, quote } = rootState.storage;
    if (state.specialNeeds.length) return;

    try {
      commit('updateRequesting', { prop: 'specialNeeds', value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/switch/pro/detail/special-needs',
        data: { switchKey, isTou: quote.isTou }
      });

      const { data } = res;
      const specialNeeds = Object.entries(
        data.specialNeedsDto.specialNeeds
      ).map((item) => ({
        id: item[0],
        label: item[1]
      }));

      commit('updateState', { prop: 'specialNeeds', value: specialNeeds });
      commit('updateRequesting', { prop: 'specialNeeds', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'specialNeeds', value: false });
    }
  },
  async getResidentialStatusList({ commit, rootState }) {
    const { switchKey, quote } = rootState.storage;

    try {
      commit('updateRequesting', { prop: 'residentialStatuses', value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/switch/pro/detail/residential-statuses',
        data: { switchKey, isTou: quote.isTou }
      });

      const { data } = res;
      const residentialStatuses = Object.entries(
        data.residentialStatusesDto.residentialStatuses
      ).map((item) => ({
        id: item[0],
        label: item[1]
      }));

      commit('updateState', {
        prop: 'residentialStatuses',
        value: residentialStatuses
      });
      commit('updateRequesting', { prop: 'residentialStatuses', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'residentialStatuses', value: false });
    }
  },
  async getDirectDebitDaysList({ state, commit, rootState }) {
    const { switchKey, quote } = rootState.storage;

    if (state.directDebitDays.length) return;

    try {
      commit('updateRequesting', { prop: 'directDebitDays', value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/switch/pro/detail/direct-debit-days',
        data: { switchKey, isTou: quote.isTou }
      });

      const { data } = res;
      const directDebitDays = Object.entries(
        data.directDebitDayOfTheMonthsDto.directDebitDayOfTheMonths
      ).map((item) => ({
        id: item[0],
        label: `${item[1]} day of the month`
      }));

      commit('updateState', {
        prop: 'directDebitDays',
        value: directDebitDays
      });
      commit('updateRequesting', { prop: 'directDebitDays', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'directDebitDays', value: false });
    }
  },
  resetList({ commit }, prop) {
    commit('updateState', { prop, value: [] });
    commit('updateRequesting', { prop, value: false });
  }
};

const mutations = {
  updateRequesting(state, { prop, value }) {
    state.requesting = {
      ...state.requesting,
      [prop]: value
    };
  },
  updateState(state, { prop, value }) {
    state[prop] = value;
  },
  resetState(state) {
    Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
